import { render, staticRenderFns } from "./CustomIcon.vue?vue&type=template&id=5c47b828&"
import script from "./CustomIcon.vue?vue&type=script&lang=js&"
export * from "./CustomIcon.vue?vue&type=script&lang=js&"
import style0 from "./CustomIcon.vue?vue&type=style&index=0&id=5c47b828&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
